// extracted by mini-css-extract-plugin
export default {"root":"cnvin9YRlvbeWYF_v2fq","single-col":"n4qual9IivyiD8rfz1iT","singleCol":"n4qual9IivyiD8rfz1iT"};